import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
    Layout,
    Card,
    List,
    Typography,
    Button,
    InputNumber,
    Tabs,
    Tag,
    Space,
    Divider,
    Form,
    Input,
    Select,
    Radio,
    DatePicker,
    Descriptions,
    Modal,
    message,
    Empty,
    Spin
} from 'antd';
import {
    ShoppingCartOutlined,
    DeleteOutlined,
    MinusOutlined,
    PlusOutlined,
    EnvironmentOutlined,
    CalendarOutlined,
    UserOutlined,
    EditOutlined,
    ArrowLeftOutlined
} from '@ant-design/icons';
import firebase from "../../firebase";
import moment from 'moment';
import 'moment/locale/ja';
import "./MobileCart.css";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Title, Text } = Typography;
const { Option } = Select;

class MobileCart extends Component {
    constructor(props) {
        super(props);
        this.itemUnsubscribes = [];
        this.state = {
            cartNo: 0,
            carts: [],
            carriage: 0,
            lastToUser: '',
            lastToUserName: '',
            lastDeliveryAddress: {},
            selectToUser: false,
            userList: {},
            loading: false,
            fetching: true,
            modalVisible: false,
            modalEmptyItem: false,
            modalEmptyCartItem: false,
        };
    }

    componentDidMount() {
        const cartNo = parseInt(this.props.id) - 1;
        this.setState({ cartNo: isNaN(cartNo) ? 0 : cartNo }, () => {
            this.getCarts();
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id || this.props.org !== prevProps.org || this.props.userOrg !== prevProps.userOrg) {
            const cartNo = parseInt(this.props.id) - 1;
            this.setState({ cartNo: isNaN(cartNo) ? 0 : cartNo }, () => {
                this.getCarts();
            });
        }
    }

    getCartData = (cartNo = this.state.cartNo) => {
        const { carts } = this.state;
        const cartData = {
            items: [],
            orderNo: '',
            toUser: '',
            toUserName: '',
            orderNouki: '最短',
            orderNoukiDay: '',
            orderNoukiDate: '',
            orderBasyo: '',
            orderPropertyName: '',
            orderZipcode: '',
            orderAddr1: '',
            orderAddr2: '',
            orderJigyosyo: '',
            orderTanto: '',
            orderPhone: '',
            orderBikou: '',
            requested: false,
        };

        if (carts[cartNo]) {
            Object.assign(cartData, carts[cartNo]);
            if (!cartData.toUser && this.state.lastToUser) {
                cartData.toUser = this.state.lastToUser;
                cartData.toUserName = this.state.lastToUserName;
            }
        }
        return cartData;
    };

    getCarts = async () => {
        this.setState({ fetching: true });
        let collection;
        if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
            collection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items');
        } else if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
            collection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items');
        } else if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
            collection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('items');
        } else if (this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
            collection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('items');
        }

        if (this.props.org && collection) {
            try {
                let cid = this.props.db.collection('carts_info').doc(this.props.user.id).collection('carts_info').doc(this.props.org.id).get();
                let cRef = this.props.db.collection('carts').doc(this.props.user.id).collection('carts').doc(this.props.org.id);
                let cd = cRef.get();
                let response = await Promise.all([cid, cd]);

                let ciDoc = response[0];
                let cDoc = response[1];
                let ciData = ciDoc.data();
                let cData = cDoc.data() || {};

                if (ciData) {
                    this.setState({
                        lastToUser: ciData.lastToUser || '',
                        lastToUserName: ciData.lastToUserName || '',
                        lastDeliveryAddress: ciData.lastDeliveryAddress || {}
                    });
                }

                let userList = {};
                let hasChanged = false;
                for (let i = 0; i < 5; i++) {
                    let cart = cData[i];
                    if (cart && cart.items) {
                        let items = cart.items;
                        await Promise.all(items.map(async (item) => {
                            let itemSell = await collection.doc(item.id).get();
                            let itemSellData = itemSell.data();
                            let prevPrice = item.price;
                            let prevDeletedItem = item.deletedItem;
                            item.deletedItem = false;

                            if (!itemSellData) {
                                item.deletedItem = true;
                                item.deletedText = '販売終了';
                            } else if (!itemSellData['price'] || (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                                item.deletedItem = true;
                                item.deletedText = '要見積';
                            } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                                item.deletedItem = true;
                                item.deletedText = '要見積';
                            } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                                let expDate = itemSellData['price'][0]['expiration_date'].toDate();
                                if ((expDate.getTime() - this.props.dateNow) < 0) {
                                    item.deletedItem = true;
                                    item.deletedText = '要見積';
                                }
                            }
                            if (!item.deletedItem) {
                                let changed = updateItemFromSellData(item, itemSellData);
                                if (changed) hasChanged = true;
                            }
                            if (prevDeletedItem !== item.deletedItem) {
                                hasChanged = true;
                            }
                            if (prevPrice !== item.price && (prevPrice === undefined || Number(prevPrice) !== Number(item.price))) {
                                hasChanged = true;
                            }
                        }));
                    }
                }
                if (hasChanged) {
                    await cRef.set(cData, { merge: true });
                }

                let total = 0;
                if (cData[this.state.cartNo] && cData[this.state.cartNo].items) {
                    cData[this.state.cartNo].items.forEach(item => {
                        if (item && !item.deletedItem) total += item.count * item.price;
                    });
                }

                let postage = this.calculateCarriage(total);

                this.setState({ carriage: postage, carts: cData, fetching: false });
                this.setupItemListeners(cData, collection);
            } catch (error) {
                console.error("Error fetching carts:", error);
                this.setState({ fetching: false });
            }
        } else {
            this.setState({ fetching: false });
        }
    };

    calculateCarriage = (total) => {
        let carriage_free = 0;
        let carriage = 0;
        if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.sellers) {
            this.props.userOrg.sellers.forEach(seller => {
                if (seller.organization === this.props.org.id) {
                    carriage_free = seller.carriage_free || 0;
                    carriage = seller.carriage || 0;
                }
            });
        }
        if (this.props.org && this.props.org.reseller && this.props.userOrg) {
            carriage_free = this.props.userOrg.carriage_free || 0;
            carriage = this.props.userOrg.carriage || 0;
        }
        return total < carriage_free ? carriage : 0;
    };

    detachItemListeners = () => {
        if (this.itemUnsubscribes && this.itemUnsubscribes.length > 0) {
            this.itemUnsubscribes.forEach(unsub => {
                if (typeof unsub === 'function') {
                    unsub();
                }
            });
            this.itemUnsubscribes = [];
        }
    };

    setupItemListeners = (cData, collection) => {
        this.detachItemListeners();
        if (!collection || !cData) return;

        let itemIds = new Set();
        for (let i = 0; i < 5; i++) {
            let cart = cData[i];
            if (cart && cart.items && Array.isArray(cart.items)) {
                cart.items.forEach(item => {
                    if (item && item.id) {
                        itemIds.add(item.id);
                    }
                });
            }
        }

        itemIds.forEach(itemId => {
            let unsub = collection.doc(itemId).onSnapshot((docSnapshot) => {
                let itemSellData = docSnapshot.data();
                this.handleRealtimeItemUpdate(itemId, itemSellData);
            }, (error) => {
                console.error('Realtime mobile cart item listener error:', itemId, error);
            });
            this.itemUnsubscribes.push(unsub);
        });
    };

    handleRealtimeItemUpdate = (itemId, itemSellData) => {
        if (!this.state.carts) return;

        let currentCarts = this.state.carts;
        let hasChanged = false;
        let updatedCarts = Array.isArray(currentCarts) ? [...currentCarts] : { ...currentCarts };

        for (let i = 0; i < 5; i++) {
            let cart = currentCarts[i];
            if (cart && cart.items && Array.isArray(cart.items)) {
                let cartChanged = false;
                let newItems = cart.items.map(item => {
                    if (item && item.id === itemId) {
                        let clonedItem = { ...item };
                        let prevPrice = clonedItem.price;
                        let prevDeletedItem = clonedItem.deletedItem;
                        clonedItem.deletedItem = false;

                        if (!itemSellData) {
                            clonedItem.deletedItem = true;
                            clonedItem.deletedText = '販売終了';
                        } else if (!itemSellData['price'] || (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                            clonedItem.deletedItem = true;
                            clonedItem.deletedText = '要見積';
                        } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                            clonedItem.deletedItem = true;
                            clonedItem.deletedText = '要見積';
                        } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                            let expDate = itemSellData['price'][0]['expiration_date'] && itemSellData['price'][0]['expiration_date'].toDate ? itemSellData['price'][0]['expiration_date'].toDate() : (itemSellData['price'][0]['expiration_date'] ? new Date(itemSellData['price'][0]['expiration_date'].seconds * 1000) : new Date(0));
                            if ((expDate.getTime() - this.props.dateNow) < 0) {
                                clonedItem.deletedItem = true;
                                clonedItem.deletedText = '要見積';
                            }
                        }

                        if (!clonedItem.deletedItem) {
                            let changed = updateItemFromSellData(clonedItem, itemSellData, false);
                            if (changed) {
                                hasChanged = true;
                                cartChanged = true;
                            }
                        }
                        if (prevDeletedItem !== clonedItem.deletedItem) {
                            hasChanged = true;
                            cartChanged = true;
                        }
                        if (prevPrice !== clonedItem.price && (prevPrice === undefined || Number(prevPrice) !== Number(clonedItem.price))) {
                            hasChanged = true;
                            cartChanged = true;
                        }
                        return clonedItem;
                    }
                    return item;
                });

                if (cartChanged) {
                    let updatedCart = { ...cart, items: newItems };
                    let hasAnyDeleted = newItems.some(it => it.deletedItem);
                    if (hasAnyDeleted) {
                        updatedCart.deletedItem = true;
                    } else {
                        delete updatedCart.deletedItem;
                        delete updatedCart.deletedText;
                    }
                    updatedCarts[i] = updatedCart;
                } else {
                    updatedCarts[i] = cart;
                }
            } else {
                updatedCarts[i] = cart;
            }
        }

        if (hasChanged) {
            let total = 0;
            if (updatedCarts[this.state.cartNo] && updatedCarts[this.state.cartNo].items) {
                updatedCarts[this.state.cartNo].items.forEach(item => {
                    if (item && !item.deletedItem) total += item.count * item.price;
                });
            }
            let postage = this.calculateCarriage(total);
            this.setState({ carts: updatedCarts, carriage: postage });

            let cRef = this.props.db.collection('carts').doc(this.props.user.id).collection('carts').doc(this.props.org.id);
            cRef.set(updatedCarts, { merge: true });
        }
    };

    componentWillUnmount() {
        this.detachItemListeners();
    }

    updateCartToFirebase = async (updatedCart) => {
        const date = firebase.firestore.Timestamp.fromDate(new Date());
        let cartMainRef = this.props.db.collection('carts').doc(this.props.user.id);
        let cartRef = cartMainRef.collection('carts').doc(this.props.org.id);

        await cartMainRef.set({ dummy: 'test' }, { merge: true });
        await cartRef.set({
            [this.state.cartNo]: updatedCart,
            update: date,
        }, { merge: true });
    };

    handleQuantityChange = (index, value) => {
        let carts = { ...this.state.carts };
        let cart = { ...carts[this.state.cartNo] };
        if (cart.requested) return;

        cart.items[index].count = value;
        carts[this.state.cartNo] = cart;

        this.setState({ carts });
        this.updateCartToFirebase(cart);
    };

    deleteItem = (index) => {
        let carts = { ...this.state.carts };
        let cart = { ...carts[this.state.cartNo] };
        if (cart.requested) return;

        cart.items.splice(index, 1);
        carts[this.state.cartNo] = cart;

        this.setState({ carts });
        this.updateCartToFirebase(cart);
    };

    handleToUserChange = (value) => {
        let carts = { ...this.state.carts };
        let cart = { ...carts[this.state.cartNo] };
        if (cart.requested) return;

        const selectedUser = this.props.org.users.find(u => u.user === value);
        cart.toUser = value;
        cart.toUserName = selectedUser ? selectedUser.name : '';

        carts[this.state.cartNo] = cart;
        this.setState({ carts });
        this.updateCartToFirebase(cart);
    };

    handleFormChange = (field, value) => {
        let carts = { ...this.state.carts };
        let cart = { ...carts[this.state.cartNo] };
        if (cart.requested) return;

        cart[field] = value;
        carts[this.state.cartNo] = cart;
        this.setState({ carts });
        this.updateCartToFirebase(cart);
    };

    requestOrder = () => {
        const cartData = this.getCartData();
        const items = cartData.items || [];
        if (items.length === 0) return;

        if (cartData.orderNouki === '日付指定' && !cartData.orderNoukiDate) {
            message.error('日付を選択してください');
            return;
        }

        if (cartData.orderBasyo === '納品先を直接入力する' &&
            !(cartData.orderPropertyName && cartData.orderZipcode && cartData.orderAddr1 && cartData.orderAddr2 && cartData.orderJigyosyo && cartData.orderTanto && cartData.orderPhone)) {
            message.error('直接入力の場合は全項目を入力してください');
            return;
        }

        if (cartData.orderBasyo === 'アドレス帳から選択する' && (!cartData.deliveryAddress || !cartData.deliveryAddress.address1)) {
            message.error('アドレス帳から納品先を選択してください');
            return;
        }

        const hasZeroQuantity = items.some(item => item.count === 0);
        if (hasZeroQuantity) {
            this.setState({ modalEmptyItem: true });
        } else {
            this.setState({ modalVisible: true });
        }
    };

    submitOrder = async (clearZero = false) => {
        this.setState({ loading: true, modalVisible: false, modalEmptyItem: false });
        try {
            let carts = { ...this.state.carts };
            let cart = this.getCartData();

            if (clearZero) {
                cart.items = cart.items.filter(item => item.count > 0);
                if (cart.items.length === 0) {
                    this.setState({ loading: false, modalEmptyCartItem: true });
                    return;
                }
            }

            cart.requested = true;
            cart.carriage = this.state.carriage;

            if (!cart.toUser && this.state.lastToUser) {
                cart.toUser = this.state.lastToUser;
                cart.toUserName = this.state.lastToUserName;
            }

            // Delivery logic
            if (cart.orderBasyo === '前回の納品先' && Object.keys(this.state.lastDeliveryAddress).length > 0) {
                cart.deliveryAddress = { ...this.state.lastDeliveryAddress };
            } else if (cart.orderBasyo === '納品先を直接入力する') {
                cart.deliveryAddress = {
                    propertyName: cart.orderPropertyName || '',
                    postCode: cart.orderZipcode || '',
                    address1: cart.orderAddr1 || '',
                    address2: cart.orderAddr2 || '',
                    officeName: cart.orderJigyosyo || '',
                    personInCharge: cart.orderTanto || '',
                    phoneNumber: cart.orderPhone || '',
                };
            } else if (cart.orderBasyo === '販売側からお助けカートで指定された納品先') {
                cart.deliveryAddress = { ...(cart.otasukeDeliveryAddress || {}) };
            }

            let orderRef = this.props.db.collection('orders').doc();
            let created = firebase.firestore.Timestamp.fromDate(new Date());
            const isSupervisor = !!this.props.user.authorizer;

            if (isSupervisor) {
                // Determine item collection for stats update
                let itemCollection;
                if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
                    itemCollection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items');
                } else if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
                    itemCollection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items');
                } else if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
                    itemCollection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('items');
                } else if (this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
                    itemCollection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('items');
                }

                // Generate item numbers and update stats
                const pad = (num) => num > 9 ? "" + num : "0" + num;
                let no = 0;
                let subDividedNo = 1;
                let returnSubNo = 1;

                await Promise.all(cart.items.map(async (item) => {
                    // Update stats
                    if (itemCollection) {
                        const itemSell = await itemCollection.doc(item.id).get();
                        const itemSellData = itemSell.data();
                        if (itemSellData && itemSellData['price']) {
                            updateItemFromSellData(item, itemSellData);
                        }

                        const itemOrderRef = this.props.db.collection('item_order')
                            .where('buyerOrg', '==', this.props.userOrg.id)
                            .where('sellerOrg', '==', this.props.org.id)
                            .where('itemId', '==', item.id);
                        const itemOrderSnapshot = await itemOrderRef.get();

                        if (itemOrderSnapshot.empty) {
                            await this.props.db.collection('item_order').add({
                                buyerOrg: this.props.userOrg.id,
                                sellerOrg: this.props.org.id,
                                itemId: item.id,
                                orderCount: 1,
                                archive: false,
                                pinned: false,
                                notCountRecommend: (itemSellData && itemSellData['notCountRecommend'] === undefined) ? false : (itemSellData ? itemSellData['notCountRecommend'] : false),
                            });
                        } else {
                            await itemOrderSnapshot.docs[0].ref.set({
                                orderCount: firebase.firestore.FieldValue.increment(1),
                            }, { merge: true });
                        }
                    }

                    // Generate display number
                    let templatedNo;
                    if (item.subDivided) {
                        templatedNo = pad(no) + '-' + subDividedNo;
                        if (item.returnSub) {
                            templatedNo = pad(no) + '-' + (subDividedNo - 1) + '-' + returnSubNo;
                            returnSubNo += 1;
                        } else {
                            returnSubNo = 1;
                            subDividedNo += 1;
                        }
                    } else {
                        if (item.returnSub) {
                            templatedNo = pad(no) + '-' + returnSubNo;
                            returnSubNo += 1;
                        } else {
                            no += 1;
                            subDividedNo = 1;
                            returnSubNo = 1;
                            templatedNo = pad(no);
                        }
                    }
                    item.no = templatedNo;
                }));
            }

            let orderData = {
                cart: cart,
                cartNo: this.state.cartNo,
                toUser: cart.toUser,
                toUserName: cart.toUserName,
                toOrganization: this.props.org.id,
                fromUser: this.props.user.id,
                fromUserName: this.props.user.last_name + ' ' + (this.props.user.first_name || ''),
                fromOrganization: this.props.userOrg?.id,
                created: created,
                latestUpdate: created,
                sortDate: created,
                wait: isSupervisor ? {} : { [this.props.user.id]: true },
                requested: !isSupervisor,
                applied: isSupervisor,
                apply: isSupervisor ? { [this.props.user.id]: true } : {},
                applyUserName: isSupervisor ? (this.props.user.last_name + ' ' + (this.props.user.first_name || '')) : '',
                orderDate: isSupervisor ? created : null,
                rejected: false,
                isShipped: false,
                newReject: false,
                newApply: isSupervisor,
                readSeller: false,
                sellerConfirm: false,
            };

            await orderRef.set(orderData);
            cart.orderId = orderRef.id;

            if (isSupervisor) {
                // Empty cart for supervisor
                await this.updateCartToFirebase({});
            } else {
                await this.updateCartToFirebase(cart);
            }

            // Update cart info
            await this.props.db.collection('carts_info').doc(this.props.user.id)
                .collection('carts_info').doc(this.props.org.id).set({
                    lastToUser: cart.toUser,
                    lastToUserName: cart.toUserName,
                    update: created
                }, { merge: true });

            message.success(isSupervisor ? '発注確定しました' : '承認依頼を送信しました');
            this.setState({ loading: false });
            this.getCarts();
        } catch (error) {
            console.error("Order submission error:", error);
            message.error('エラーが発生しました');
            this.setState({ loading: false });
        }
    };

    render() {
        const { carts, cartNo, fetching, loading, carriage } = this.state;
        const { org, user } = this.props;

        if (!org) return <div style={{ padding: 20 }}>取引先を選択してください</div>;
        if (fetching) return <div style={{ display: 'flex', justifyContent: 'center', padding: 50 }}><Spin size="large" /></div>;

        const cartData = this.getCartData();
        const items = cartData.items || [];

        let subtotal = 0;
        let taxTotal = 0;
        const taxes = {};

        items.forEach(item => {
            if (!item.deletedItem) {
                const itemTotal = item.count * item.price;
                subtotal += itemTotal;
                const tax = item.tax || 0.1;
                const itemTax = Math.floor(itemTotal * tax);
                taxTotal += itemTax;
                taxes[tax] = (taxes[tax] || 0) + itemTax;
            }
        });

        const grandTotal = subtotal + carriage + taxTotal;

        const isDisable = cartData.toUser === '' || cartData.orderBasyo === '' || items.length === 0 || items.some(i => i.archive) || items.some(i => i.deletedItem);

        return (
            <div className="mobile-cart-container">
                <div className="mobile-cart-header">
                    <Button icon={<ArrowLeftOutlined />} onClick={() => this.props.history.goBack()} type="text" />
                    <Title level={4} style={{ margin: 0 }}>カート {cartNo + 1}</Title>
                </div>

                <Tabs
                    activeKey={(cartNo + 1).toString()}
                    onChange={(key) => this.props.history.push(`/cart/${key}`)}
                    className="mobile-cart-tabs"
                >
                    {[1, 2, 3, 4, 5].map(i => <Tabs.TabPane tab={`カート${i}`} key={i.toString()} />)}
                </Tabs>

                <List
                    dataSource={items}
                    renderItem={(item, index) => (
                        <Card className="mobile-cart-item-card" bodyStyle={{ padding: 12 }}>
                            <div className="mobile-cart-item-content">
                                <div className="mobile-cart-item-header">
                                    <div style={{ flex: 1 }}>
                                        <Link to={`/items/${item.id}`} className="mobile-cart-item-name">{item.name}</Link>
                                        <div className="mobile-cart-item-maker">{item.maker}</div>
                                        {item.archive && <Tag color="error">現在お取り扱いしていません</Tag>}
                                    </div>
                                    <Button
                                        type="text"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={() => this.deleteItem(index)}
                                        disabled={cartData.requested}
                                    />
                                </div>

                                <div className="mobile-cart-item-price-row">
                                    <div className="mobile-cart-item-unit-price">
                                        {item.deletedItem ? <Text type="danger">{item.deletedText}</Text> : `単価: ¥${item.price.toLocaleString()}`}
                                    </div>
                                    <div className="mobile-cart-item-total-price">
                                        {!item.deletedItem && `¥${(item.count * item.price).toLocaleString()}`}
                                    </div>
                                </div>

                                <div className="mobile-cart-quantity-controls">
                                    <Button
                                        icon={<MinusOutlined />}
                                        onClick={() => this.handleQuantityChange(index, Math.max(0, item.count - 1))}
                                        disabled={item.count <= 0 || cartData.requested}
                                    />
                                    <InputNumber
                                        min={0}
                                        value={item.count}
                                        onChange={(val) => this.handleQuantityChange(index, val)}
                                        disabled={cartData.requested}
                                        style={{ width: 60 }}
                                    />
                                    <Button
                                        icon={<PlusOutlined />}
                                        onClick={() => this.handleQuantityChange(index, item.count + 1)}
                                        disabled={cartData.requested}
                                    />
                                </div>

                                <Input.TextArea
                                    placeholder="備考"
                                    rows={2}
                                    value={item.description}
                                    onChange={(e) => this.handleFormChange('items', items.map((it, i) => i === index ? { ...it, description: e.target.value } : it))}
                                    disabled={cartData.requested}
                                    style={{ marginTop: 12 }}
                                />
                            </div>
                        </Card>
                    )}
                    locale={{ emptyText: <Empty description="カートは空です" /> }}
                />

                {items.length > 0 && (
                    <div className="mobile-cart-form-section">
                        <Form layout="vertical">
                            <Form.Item label={<span>発注番号 <Tag color="#707070" style={{ color: "white", borderRadius: "2px", fontSize: "11px", marginLeft: "4px", padding: "0 4px", lineHeight: "18px" }}>任意</Tag></span>}>
                                <Input
                                    placeholder="発注番号"
                                    value={cartData.orderNo}
                                    onChange={(e) => this.handleFormChange('orderNo', e.target.value)}
                                    disabled={cartData.requested}
                                />
                            </Form.Item>

                            <Form.Item label={<span>相手先営業担当者選択 <Tag color="#FF0000" style={{ color: "white", borderRadius: "2px", fontSize: "11px", marginLeft: "4px", padding: "0 4px", lineHeight: "18px" }}>必須</Tag></span>}>
                                <Select
                                    placeholder="選択してください"
                                    value={cartData.toUser || undefined}
                                    onChange={this.handleToUserChange}
                                    disabled={cartData.requested}
                                >
                                    {org.users && org.users.map(u => <Option key={u.user} value={u.user}>{u.name}</Option>)}
                                </Select>
                            </Form.Item>

                            <Form.Item label={<span>希望納期 <Tag color="#FF0000" style={{ color: "white", borderRadius: "2px", fontSize: "11px", marginLeft: "4px", padding: "0 4px", lineHeight: "18px" }}>必須</Tag></span>}>
                                <Radio.Group
                                    value={cartData.orderNouki || '最短'}
                                    onChange={(e) => this.handleFormChange('orderNouki', e.target.value)}
                                    disabled={cartData.requested}
                                >
                                    <Space direction="vertical">
                                        <Radio value="最短">最短</Radio>
                                        <Radio value="希望">
                                            <Space>
                                                <InputNumber
                                                    min={0}
                                                    value={cartData.orderNoukiDay}
                                                    onChange={(val) => this.handleFormChange('orderNoukiDay', val)}
                                                    disabled={cartData.requested || cartData.orderNouki !== '希望'}
                                                    size="small"
                                                />
                                                日
                                            </Space>
                                        </Radio>
                                        <Radio value="日付指定">
                                            <DatePicker
                                                value={cartData.orderNoukiDate ? moment(cartData.orderNoukiDate.toDate()) : null}
                                                onChange={(date) => this.handleFormChange('orderNoukiDate', date ? firebase.firestore.Timestamp.fromDate(date.toDate()) : null)}
                                                disabled={cartData.requested || cartData.orderNouki !== '日付指定'}
                                                style={{ width: '100%' }}
                                            />
                                        </Radio>
                                    </Space>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item label={<span>納品場所 <Tag color="#FF0000" style={{ color: "white", borderRadius: "2px", fontSize: "11px", marginLeft: "4px", padding: "0 4px", lineHeight: "18px" }}>必須</Tag></span>}>
                                <Radio.Group
                                    value={cartData.orderBasyo}
                                    onChange={(e) => this.handleFormChange('orderBasyo', e.target.value)}
                                    disabled={cartData.requested}
                                    style={{ width: '100%' }}
                                >
                                    <Space direction="vertical" style={{ width: '100%' }}>
                                        <Card size="small" style={{ width: '100%' }}>
                                            <Radio value="前回の納品先" disabled={!Object.keys(this.state.lastDeliveryAddress).length}>
                                                前回の納品先
                                            </Radio>
                                            {this.state.lastDeliveryAddress.address1 && (
                                                <div style={{ fontSize: 12, color: '#666', marginTop: 4, paddingLeft: 24 }}>
                                                    {this.state.lastDeliveryAddress.propertyName}<br />
                                                    {this.state.lastDeliveryAddress.address1} {this.state.lastDeliveryAddress.address2}
                                                </div>
                                            )}
                                        </Card>

                                        <Card size="small" style={{ width: '100%' }}>
                                            <Radio value="アドレス帳から選択する">
                                                アドレス帳から選択する
                                            </Radio>
                                            <Button
                                                size="small"
                                                icon={<EnvironmentOutlined />}
                                                onClick={() => this.props.history.push(`/deliveryAddress?cn=${cartNo + 1}&ct=normal`)}
                                                disabled={cartData.requested}
                                                style={{ marginLeft: 24, marginTop: 8 }}
                                            >
                                                アドレス帳を開く
                                            </Button>
                                            {cartData.deliveryAddress && cartData.deliveryAddress.address1 && (
                                                <div style={{ fontSize: 12, color: '#666', marginTop: 4, paddingLeft: 24 }}>
                                                    {cartData.deliveryAddress.propertyName}<br />
                                                    {cartData.deliveryAddress.address1} {cartData.deliveryAddress.address2}
                                                </div>
                                            )}
                                        </Card>

                                        <Card size="small" style={{ width: '100%' }}>
                                            <Radio value="納品先を直接入力する">
                                                納品先を直接入力する
                                            </Radio>
                                            {cartData.orderBasyo === '納品先を直接入力する' && (
                                                <div style={{ marginTop: 12, paddingLeft: 24 }}>
                                                    <Input placeholder="物件名" value={cartData.orderPropertyName} onChange={(e) => this.handleFormChange('orderPropertyName', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                    <Input placeholder="郵便番号" value={cartData.orderZipcode} onChange={(e) => this.handleFormChange('orderZipcode', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                    <Input placeholder="住所1" value={cartData.orderAddr1} onChange={(e) => this.handleFormChange('orderAddr1', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                    <Input placeholder="住所2" value={cartData.orderAddr2} onChange={(e) => this.handleFormChange('orderAddr2', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                    <Input placeholder="事業所名" value={cartData.orderJigyosyo} onChange={(e) => this.handleFormChange('orderJigyosyo', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                    <Input placeholder="担当者名" value={cartData.orderTanto} onChange={(e) => this.handleFormChange('orderTanto', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                    <Input placeholder="電話番号" value={cartData.orderPhone} onChange={(e) => this.handleFormChange('orderPhone', e.target.value)} disabled={cartData.requested} />
                                                </div>
                                            )}
                                        </Card>

                                        {cartData.orderBasyo === '販売側からお助けカートで指定された納品先' && (
                                            <Card size="small" style={{ width: '100%' }}>
                                                <Radio value="販売側からお助けカートで指定された納品先">
                                                    販売側からお助けカートで指定された納品先
                                                </Radio>
                                                {cartData.otasukeDeliveryAddress && (
                                                    <div style={{ fontSize: 12, color: '#666', marginTop: 4, paddingLeft: 24, lineHeight: '1.6' }}>
                                                        <div>物件名：{cartData.otasukeDeliveryAddress.propertyName}</div>
                                                        <div>{cartData.otasukeDeliveryAddress.postCode}</div>
                                                        <div>{cartData.otasukeDeliveryAddress.address1} {cartData.otasukeDeliveryAddress.address2} {cartData.otasukeDeliveryAddress.officeName}</div>
                                                        <div>受取担当者：{cartData.otasukeDeliveryAddress.personInCharge}</div>
                                                        <div>電話番号：{cartData.otasukeDeliveryAddress.phoneNumber}</div>
                                                    </div>
                                                )}
                                            </Card>
                                        )}

                                        <Card size="small" style={{ width: '100%' }}>
                                            <Radio value="納品先を指定しない">
                                                納品先を指定しない
                                            </Radio>
                                        </Card>
                                    </Space>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item label={<span>備考 <span className="cart-require-any">任意</span></span>}>
                                <Input.TextArea
                                    rows={3}
                                    value={cartData.orderBikou}
                                    onChange={(e) => this.handleFormChange('orderBikou', e.target.value)}
                                    disabled={cartData.requested}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                )}

                {items.length > 0 && (
                    <div className="mobile-cart-footer">
                        <div className="mobile-cart-summary">
                            <div className="mobile-cart-summary-row">
                                <Text>運賃</Text>
                                <Text>¥{carriage.toLocaleString()}</Text>
                            </div>
                            <div className="mobile-cart-summary-row">
                                <Text>消費税額</Text>
                                <Text>¥{taxTotal.toLocaleString()}</Text>
                            </div>
                            <div className="mobile-cart-summary-row">
                                <Text className="mobile-cart-total-label">合計 (税込)</Text>
                                <Text className="mobile-cart-total-value">¥{grandTotal.toLocaleString()}</Text>
                            </div>
                        </div>

                        {cartData.requested ? (
                            <div style={{ background: '#fff7e6', padding: '12px', textAlign: 'center', borderRadius: '8px', border: '1px solid #ffd591', color: '#fa8c16', fontWeight: 'bold' }}>
                                承認依頼中
                            </div>
                        ) : (
                            <Button
                                type="primary"
                                size="large"
                                block
                                loading={loading}
                                disabled={isDisable}
                                onClick={this.requestOrder}
                                style={{ backgroundColor: '#00C851', borderColor: '#00C851' }}
                            >
                                {this.props.user.authorizer ? '発注確定' : '上長承認依頼'}
                            </Button>
                        )}
                    </div>
                )}

                <Modal
                    title="承認依頼"
                    visible={this.state.modalVisible}
                    onOk={() => this.submitOrder()}
                    onCancel={() => this.setState({ modalVisible: false })}
                    okText="依頼する"
                    cancelText="キャンセル"
                >
                    <p>{this.props.user.authorizer ? '発注確定をします。よろしいですか？' : '上長に承認依頼をします。よろしいですか？'}</p>
                </Modal>

                <Modal
                    title="承認依頼"
                    visible={this.state.modalEmptyItem}
                    onOk={() => this.submitOrder(true)}
                    onCancel={() => this.setState({ modalEmptyItem: false })}
                    okText="削除して依頼する"
                    cancelText="キャンセル"
                >
                    <p>数量0の商品が含まれています。これらを削除して{this.props.user.authorizer ? '発注確定' : '承認依頼'}を続行しますか？</p>
                </Modal>
            </div>
        );
    }
}

export default withRouter(MobileCart);
